import React, { useState } from "react";
import {
  Row,
  Col,
  Tooltip,
  OverlayTrigger,
  Button,
  Modal,
} from "react-bootstrap";
import { IoMdPerson } from "react-icons/io";
import { FaTrash } from "react-icons/fa";
import { useAuth } from "../../Context/AuthContext";
import { useTranslation } from "react-i18next"; // Importer useTranslation
import "./MemberItem.css";

function MemberItem({
  first_name,
  last_name,
  role,
  id,
  handleDelete,
  programCreator,
}) {
  const { t } = useTranslation(); // Assigner useTranslation à {t}
  const { authData } = useAuth();

  const [showModal, setShowModal] = useState(false);

  const handleModalClose = () => setShowModal(false);
  const handleModalShow = (userId) => {
    setShowModal(true);
  };

  const renderToolTip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {id === programCreator ? t("exclude_from_course") : t("leave_course")}
    </Tooltip>
  );

  return (
    <Row
      className="border bg-light py-2"
      style={{ backgroundColor: id % 2 !== 0 ? "#f8f9fa" : "white" }}
    >
      <Col className="d-flex align-items-center">
        <IoMdPerson className="me-2" />
        {first_name} {last_name}
      </Col>
      <Col>{id === programCreator ? t("teacher") : t("student")}</Col>

      <Col sm={1} className="d-flex align-items-center">
        {(authData.userId === id || authData.userId === programCreator) &&
          id !== programCreator && (
            <OverlayTrigger placement="top" overlay={renderToolTip}>
              <FaTrash className="icon" onClick={() => handleModalShow(id)} />
            </OverlayTrigger>
          )}
      </Col>
      <Modal show={showModal} onHide={handleModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>{t("confirm_deletion")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {authData.userId === programCreator
            ? t("confirm_exclude_student")
            : t("confirm_leave_program")}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleModalClose}>
            {t("cancel")}
          </Button>
          <Button variant="danger" onClick={() => handleDelete(id)}>
            {authData.userId === programCreator
              ? t("exclude_student")
              : t("leave_program")}
          </Button>
        </Modal.Footer>
      </Modal>
    </Row>
  );
}

export default MemberItem;
